import { motion } from 'framer-motion'
import { Mail, MapPin, Building2, Phone } from 'lucide-react'
import MarketingNav from '@/components/marketing/MarketingNav'
import MarketingFooter from '@/components/marketing/MarketingFooter'

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <MarketingNav />
      
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 gradient-mesh opacity-30" />
        <div className="absolute inset-0 grid-pattern" />
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ai-500/10 border border-ai-500/20 mb-8"
          >
            <Mail className="w-4 h-4 text-ai-400" />
            <span className="text-sm font-medium text-ai-300">Contact</span>
          </motion.div>
          
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6"
          >
            Get in Touch
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-surface-300 max-w-2xl mx-auto leading-relaxed"
          >
            Have questions about 3DMakerly? We'd love to hear from you.
          </motion.p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="p-8 rounded-2xl bg-surface-900/50 border border-surface-700/50"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary-500/10 mb-6">
                <Mail className="w-6 h-6 text-primary-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Email Us</h3>
              <p className="text-surface-400 mb-4">For general enquiries and support</p>
              <a href="mailto:hello@3dmakerly.com" className="text-primary-400 hover:text-primary-300 transition-colors">
                hello@3dmakerly.com
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="p-8 rounded-2xl bg-surface-900/50 border border-surface-700/50"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-ai-500/10 mb-6">
                <Building2 className="w-6 h-6 text-ai-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Registered Office</h3>
              <p className="text-surface-400">
                Interlink Digital Group Limited<br />
                t/a 3DMakerly<br />
                27 Old Gloucester Street<br />
                London, WC1N 3AX<br />
                United Kingdom
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="p-8 rounded-2xl bg-surface-900/50 border border-surface-700/50"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-success-500/10 mb-6">
                <MapPin className="w-6 h-6 text-success-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Company Details</h3>
              <p className="text-surface-400">
                Company Registration: 05431902<br />
                VAT Number: GB132978001
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="p-8 rounded-2xl bg-surface-900/50 border border-surface-700/50"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-warning-500/10 mb-6">
                <Phone className="w-6 h-6 text-warning-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Parent Company</h3>
              <p className="text-surface-400 mb-4">3DMakerly is a trading name of</p>
              <a href="https://interlink.digital/" className="text-primary-400 hover:text-primary-300 transition-colors">
                Interlink Digital Group Limited
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  )
}
